import React, { useEffect, useState, useRef } from "react";
import AlarmTooltipComponent from "./AlarmTooltip.component";
import { getAlarmList } from "api/student/v2/alarm.api";

const AlarmTooltipContainer = (props: any) => {
    const { onClose } = props;
    const [isInit, setIsInit] = useState(false);
    const [list, setList] = useState<any[]>([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const tooltipRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const fetchAlarmList = async () => {
            try {
                const data = await getAlarmList(page, limit, true);
                if (data.list) {
                    setList(data.list);
                    setIsInit(true);
                }
            } catch (error) {
                console.error("알림 목록 가져오기 실패:", error);
            }
        };
        fetchAlarmList();
    }, []);

    // 외부 클릭 감지하여 툴팁 닫기
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
                onClose();
            }
        };

        // 이벤트 리스너 등록
        document.addEventListener('mousedown', handleClickOutside);

        // 컴포넌트 언마운트 시 이벤트 리스너 제거
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    return <AlarmTooltipComponent ref={tooltipRef} list={list} onClose={onClose} isInit={isInit} />;
};

export default AlarmTooltipContainer;